export { ExameSolicitado } from './ExameSolicitado'
